import FJLocalStore from '../../../store/FJLocalStore';
import styles from './FJFreeTimesSpan.module.less';
import PropTypes from 'prop-types';
import classnames from 'classnames';
const FJFreeTimesSpan = props => {
    const { times = 20, className, desc } = props;
    if (times <= 0) {
        return null;
    }
    const content =
        times > 1
            ? FJLocalStore._('free-tries-left').replace('xxx', `<span>${times}</span>`)
            : FJLocalStore._('free-trie-left').replace('1', `<span>1</span>`);

    return (
        <div
            className={classnames(styles.btn_desc, className)}
            dangerouslySetInnerHTML={{
                __html: desc || content,
            }}
        />
    );
};

FJFreeTimesSpan.propTypes = {
    times: PropTypes.number,
    className: PropTypes.string,
};

export default FJFreeTimesSpan;
